import { render, staticRenderFns } from "./wyModalEditTPProblem.vue?vue&type=template&id=602893f5&"
import script from "./wyModalEditTPProblem.vue?vue&type=script&lang=js&"
export * from "./wyModalEditTPProblem.vue?vue&type=script&lang=js&"
import style0 from "./wyModalEditTPProblem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports